import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { coalesceReportRisks } from '../../../../lib/parseStringRiskEntries';
import { TypedRiskMatrixPanel } from '../../report/TypedRiskMatrixPanel';
import { SectionShell } from '../SectionShell';

export const PowerRiskMatrixSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const risks = coalesceReportRisks(
    report.developmentRisks,
    [
      report.powerAnalysis?.risks,
      report.conclusion?.topRisks,
    ],
  );

  return (
    <SectionShell label={label} hasData={risks.length > 0} report={report} sectionId="powerRiskMatrix">
      <TypedRiskMatrixPanel
        risks={risks}
        references={report.references}
        testIdPrefix="power-risk-matrix"
      />
    </SectionShell>
  );
};
